var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { Menu } from '@headlessui/react';
import { useTranslation } from 'react-i18next';
const RemoveUserMenuItem = ({ userId, onOpenAlert, }) => {
    _react_refresh_temp_2();
    const { t } = useTranslation();
    const onClose = () => {
        onOpenAlert(userId, 'remove');
    };
    const render = () => {
        return (_jsx(_Fragment, { children: _jsx("div", { className: "", role: "none", children: _jsx(Menu.Item, { children: () => (_jsx("button", { className: "text-red-900 group flex rounded-md items-center text-left w-full px-2 py-[0.4rem] text-xs lg:text-sm transition ease-in hover:bg-red-400 hover:text-white", onClick: () => onClose(), children: t('left-panel.menus.items.remove-participant') })) }) }) }));
    };
    return _jsx(_Fragment, { children: render() });
};
_react_refresh_temp_1 = RemoveUserMenuItem;
$RefreshReg$(_react_refresh_temp_1, "RemoveUserMenuItem");
_react_refresh_temp_2(RemoveUserMenuItem, "zlIdU9EjM2llFt74AbE2KsUJXyM=", false, () => [useTranslation]);
export default RemoveUserMenuItem;
